import { useState, useEffect } from 'react';
import SEO from './SEO';
import './UnderConstruction.css';

const PRODUCTS = [
  {
    name: 'LIPI.AI',
    url: 'https://lipi.ai',
    icon: '\u25C8',
    desc: 'AI-powered fonts & typography tools',
  },
  {
    name: 'WATCHDOG.TO',
    url: 'https://watchdog.to',
    icon: '\u25CE',
    desc: 'In-app safety & content checks',
  },
  {
    name: 'HOITY.NET',
    url: 'https://hoity.net',
    icon: '\u25C7',
    desc: 'Learn world cultures, one lesson at a time',
  },
];

const TERMINAL_TEXT = 'systems upgrading... we will be back shortly_';

function TypingText({ text }) {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      if (i < text.length) {
        setDisplayed(text.slice(0, i + 1));
        i++;
      } else {
        clearInterval(timer);
      }
    }, 50);
    return () => clearInterval(timer);
  }, [text]);

  return (
    <span>
      <span className="uc-prompt">&gt;_</span>
      {displayed}
      <span className="uc-cursor" />
    </span>
  );
}

function HomePage() {
  return (
    <>
      <SEO
        title="GetMyst — Under Construction"
        description="GetMyst is upgrading. Meanwhile, check out our other products: lipi.ai, watchdog.to, and hoity.net."
        name="GetMyst.app"
        type="website"
        url="https://getmyst.app"
      />

      <div className="uc-page">
        {/* Background layers */}
        <div className="uc-scanlines" />
        <div className="uc-noise" />
        <div className="uc-grid-floor" />
        <div className="uc-glow uc-glow--1" />
        <div className="uc-glow uc-glow--2" />
        <div className="uc-hex-deco uc-hex-deco--1" />
        <div className="uc-hex-deco uc-hex-deco--2" />

        {/* Corner brackets */}
        <div className="uc-corner uc-corner--tl" />
        <div className="uc-corner uc-corner--tr" />
        <div className="uc-corner uc-corner--bl" />
        <div className="uc-corner uc-corner--br" />

        {/* Data streams */}
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="uc-data-stream" />
        ))}

        {/* Main content */}
        <div className="uc-content">
          <div className="uc-fade-in uc-fade-in--d1">
            <div className="uc-status">
              <span className="uc-status-dot" />
              System Maintenance
            </div>
          </div>

          <div className="uc-title-wrapper uc-fade-in uc-fade-in--d2">
            <h1 className="uc-title" data-text="Under Construction">
              Under Construction
            </h1>
          </div>

          <div className="uc-terminal uc-fade-in uc-fade-in--d3">
            <div className="uc-terminal-line">
              <TypingText text={TERMINAL_TEXT} />
            </div>
          </div>

          <div className="uc-separator uc-fade-in uc-fade-in--d4">
            <div className="uc-separator-line" />
            <span className="uc-separator-icon">&#x2B22; &#x2B22; &#x2B22;</span>
            <div className="uc-separator-line" />
          </div>

          <div className="uc-fade-in uc-fade-in--d5">
            <p className="uc-products-label">Meanwhile, try out other products</p>
          </div>

          <div className="uc-products-grid">
            {PRODUCTS.map((product) => (
              <a
                key={product.name}
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                className="uc-card"
              >
                <div className="uc-card-icon">{product.icon}</div>
                <div className="uc-card-name">{product.name}</div>
                <div className="uc-card-desc">{product.desc}</div>
                <div className="uc-card-arrow">Visit &rarr;</div>
              </a>
            ))}
          </div>
        </div>

        <div className="uc-footer uc-fade-in uc-fade-in--d6">
          GetMyst &mdash; We&apos;ll be back
        </div>
      </div>
    </>
  );
}

export default HomePage;
